import React from "react";

export const Video = ({ youtubeVideos }) => {
  return (
    <>
      <section class="section-bg layout-pt-md layout-pb-md">
        <div class="container">
          <div class="row">
            {youtubeVideos?.length > 0 &&
              youtubeVideos?.map((video) => {
                return (
                  <div class="col-md-6 col-lg-6">
                    <div
                      // data-anim="fade delay-1"
                      class="section-bg__item py-10"
                      data-parallax="0.7"
                    >
                      <div class="rounded-22 overflow-hidden h-300">
                        <iframe
                          width="100%"
                          height="300"
                          src={video?.Link}
                          frameBorder="0"
                          allow="autoplay; encrypted-media"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>
                  </div>
                );
              })}
            {/* <div class="col-md-6 col-lg-6">
              <div
                // data-anim="fade delay-1"
                class="section-bg__item py-10"
                data-parallax="0.7"
              >
                <div class="rounded-22 overflow-hidden h-300">
                  <iframe
                    width="100%"
                    height="300"
                    src="https://www.youtube-nocookie.com/embed/tgbNymZ7vqY?playlist=tgbNymZ7vqY&loop=1&controls=0&showinfo=0&rel=0&iv_load_policy=3"
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
};
